import { render, staticRenderFns } from "./RegistrarBajaSim.vue?vue&type=template&id=ba625c1e&"
import script from "./RegistrarBajaSim.vue?vue&type=script&lang=ts&"
export * from "./RegistrarBajaSim.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrarBajaSim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ba625c1e', component.options)
    } else {
      api.reload('ba625c1e', component.options)
    }
    module.hot.accept("./RegistrarBajaSim.vue?vue&type=template&id=ba625c1e&", function () {
      api.rerender('ba625c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/RegistrarBajaSim/RegistrarBajaSim.vue"
export default component.exports